import { createCustomVerseSchema, getVersesQuerySchema } from '@messenger/types'
import type {
  CategorizedCustomVerses,
  GetCustomVersesNormalized,
} from '@messenger/types'
import axios from '@/api/axios.config'
import { z } from 'zod'

export const getCustomVerses = async (
  themeId: z.infer<typeof getVersesQuerySchema>['themeId'],
  baseProductId: z.infer<typeof getVersesQuerySchema>['baseProductId'],
  orderProductId: z.infer<typeof getVersesQuerySchema>['orderProductId'],
) => {
  const params = {
    ...(themeId && { themeId }),
    ...(baseProductId && { baseProductId }),
    ...(orderProductId && { orderProductId }),
  }

  return await axios.get<CategorizedCustomVerses>(`customVerses`, { params })
}

export const uploadStylizedVerseImage = async (payload: FormData) => {
  return await axios.post(`uploadVerseImage`, payload, {
    headers: { 'content-type': 'form-data' },
  })
}

export const removeStylizedVerseImage = async (verseId: string) => {
  return await axios.delete<{ success: boolean }>(
    `customVerses/image/${verseId}`,
  )
}

export const createCustomVerse = async (
  payload: z.infer<typeof createCustomVerseSchema>,
) => {
  return await axios.post<GetCustomVersesNormalized>(
    `createCustomVerse`,
    payload,
  )
}

export const updateCustomVerse = async (
  id: string,
  payload: z.infer<typeof createCustomVerseSchema>,
) => {
  return await axios.patch<GetCustomVersesNormalized>(
    `customVerses/${id}`,
    payload,
  )
}

export const deleteCustomVerse = async (id: string) => {
  return await axios.delete<{ success: boolean }>(`customVerses/${id}`)
}
